import axiosClient from "./axiosClient";

const countriesApi = {
    getAll: () =>{
        const url = 'api/country/getall'
        return axiosClient.get(url)
    },
    getById: (params) =>{
        const url = `api/country/${params}`
        return axiosClient.get(url,params)
    },    
}
export default countriesApi;